// extracted by mini-css-extract-plugin
module.exports = {"price":"Price_price__qHqZv","pricePrefix":"Price_price-prefix__WBKXH","newPrice":"Price_new-price__VCcp4","newPricePrefix":"Price_new-price-prefix__NFqQv"};